import { CONFIG } from '@plugins/service/api/urls.js'

const expireTime = 60 * 60 * 24 * 90
const dateIso = () => {
  const date = new Date()
  const iso = date.toISOString()
  const splitIso = iso.split('T')
  const thisDate = splitIso[0]
  const thisTime = splitIso[1].split('.')[0]
  return `${thisDate}T${thisTime}`
}
export const state = () => ({
  settings: {
    ostadbank_support_phone: {
      code: null,
      number: null
    }
  },
  is_show_message_response: true,
  steps_teacher_request: {},
  is_modal: false,
  loadingBtnBooking: false,
  displayNavbar: true,
  windowOffsetTop: 0,
  hiddenBtnCall: false,
  isProgress: false,
  storeCanonical: process.env.app_main_canonical
})
export const mutations = {
  SET_SETTING: (state, data) => (state.settings = data),
  SET_PROGRESS_STATE: (state, data) => (state.isProgress = data),
  SET_STATE_BTN_CALL: (state, data) => (state.hiddenBtnCall = data),
  SET_OFFSET_TOP_WINDOWS: (state, data) => (state.windowOffsetTop = data),
  SET_DISPLAY_NAVBAR: (state, data) => (state.displayNavbar = data),
  SET_LOADING_BOOKING: (state, data) => (state.loadingBtnBooking = data),
  SET_MODAL: (state, data) => (state.is_modal = data),
  SET_SHOW_MESSAGE: (state, data) => (state.is_show_message_response = data),
  SET_STEPS_TEACHER_REQUEST: (state, data) => (state.steps_teacher_request = data),
  SET_CANONICAL: (state, data) => (state.storeCanonical = data)
}
export const actions = {
  async setSettings ({ commit }) {
    const settings = {
      ostadbank_support_phone: {
        code: this.$config.support_code,
        number: this.$config.support_number
      }
    }
    await commit('SET_SETTING', settings)
  },
  async nuxtServerInit ({ dispatch, commit }, { query, req, $config }) {
    await dispatch('setCookieQuery', query)
    await dispatch('setCookieReferral', req)
    await dispatch('navbar/getImportantCourse')
    await dispatch('navbar/getCourse', { course_group_id: null })
    const settings = {
      ostadbank_support_phone: {
        code: $config.support_code,
        number: $config.support_number
      }
    }
    commit('SET_SETTING', settings)
    // await dispatch('navbar/getImportantCourse')
    // await dispatch('navbar/getCourse', { course_group_id: null })
  },
  getConfig () {
    return this.$api.index({
      url: CONFIG
    })
  },
  setCookieQuery ({}, query) {
    try {
      let SOURCE_NAME_OF_OSTADBANK = null
      const thisDate = dateIso()
      if (query.source_name) {
        SOURCE_NAME_OF_OSTADBANK = query.source_name
      }
      if (query.utm_campaign) {
        SOURCE_NAME_OF_OSTADBANK = query.utm_campaign
      }
      if (SOURCE_NAME_OF_OSTADBANK) {
        SOURCE_NAME_OF_OSTADBANK = SOURCE_NAME_OF_OSTADBANK + '##' + thisDate
        this.$cookies.set('SOURCE_NAME_OF_OSTADBANK', SOURCE_NAME_OF_OSTADBANK, {
          maxAge: expireTime,
          path: '/'
        })
      }
    } catch (e) {
      console.log('setCookieQuery')
      this.$logger.captureException({ error: e })
    }
  },
  setCookieReferral ({}, req) {
    try {
      const headers = req.headers
      const { referer = null } = headers
      if (!referer) {
        return
      }
      let REFERRAL_URL_OF_OSTADBANK = referer
      const thisDate = dateIso()
      const pervUrl = new URL(referer)
      if (pervUrl.host === 'shaparak.ir') {
        return
      }
      if (pervUrl.host === 'www.ostadbank.com' && !pervUrl.href.includes('/mag')) {
        return
      }
      if (REFERRAL_URL_OF_OSTADBANK) {
        REFERRAL_URL_OF_OSTADBANK = REFERRAL_URL_OF_OSTADBANK + '##' + thisDate
        this.$cookies.set('REFERRAL_URL_OF_OSTADBANK', REFERRAL_URL_OF_OSTADBANK, {
          maxAge: expireTime,
          path: '/'
        })
      }
    } catch (e) {
      console.log('setCookieReferral')
      this.$logger.captureException({ error: e })
    }
  }
}
